import type { ReactNode } from 'react'
import { cn } from '@/common/lib/cn/cn'

type StickyBottomBarProps = {
    children: ReactNode
    className?: string
    contentClassName?: string
}

export const StickyBottomBar = ({ children, className, contentClassName }: StickyBottomBarProps) => {
    return (
        <div
            className={cn(
                'sticky bottom-0 z-100 px-4 absolute left-[-20px] right-[-20px] fixed flex justify-center',
                className
            )}
        >
            <div
                className={cn(
                    'min-h-screen max-w-7xl bg-base-100 flex-1',
                    'border-t border-[var(--pixorion-table-grey)]',
                    'bg-base-100 sticky top-0 min-h-[69px]',
                    'mx-auto flex w-full p-4 pr-10',
                    'justify-end',
                    'flex items-center gap-x-5',
                    contentClassName
                )}
            >
                {children}
            </div>
        </div>
    )
}
